import React, { Component } from 'react';
import { Table, Icon, Loader } from 'semantic-ui-react';
import DownloadFromRef from '../../../common/DownloadFromRef';
import DeleteRecord from '../../../common/DeleteRecord';
import { FIREBASEREF_UPLOADS } from '../../../globals';

import FileTableFinalCheckbox from './FileTableFinalCheckbox';
import FileTableErrorCell from './FileTableErrorCell';

class FileTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      downloadingResult: false,
      downloadingDetailed: false,
      downloadingOriginal: false,
      loadingFinal: false
    };

    this.downloadOriginal = this.downloadOriginal.bind(this);
    this.downloadResult = this.downloadResult.bind(this);
    this.downloadDetailedResult = this.downloadDetailedResult.bind(this);
    this.doneDownloadingResult = this.doneDownloadingResult.bind(this);
    this.doneDownloadingDetailed = this.doneDownloadingDetailed.bind(this);
    this.doneDownloadingOriginal = this.doneDownloadingOriginal.bind(this);
  }

  downloadOriginal() {
    this.setState({ downloadingOriginal: true });
    const ref = FIREBASEREF_UPLOADS + "/" + this.props.tour_operator + '/' + this.props.uid + '/' + this.props.uploadId;

    let fn = "upload" + this.props.timestamp + ".csv";
    if (this.props.description) fn = this.props.description + ".csv";
    else if (this.props.originalFilename) fn = this.props.originalFilename;

    DownloadFromRef(ref, fn, this.doneDownloadingOriginal);
  }

  doneDownloadingOriginal() {
    this.setState({ downloadingOriginal: false });
  }

  downloadResult() {
    if (!this.props.result || this.props.result === "") return;
    this.setState({ downloadingResult: true });
    console.log("Downloading result");
    DownloadFromRef(this.props.result, "Transavia_PQ_Result.csv", this.doneDownloadingResult);
  }

  doneDownloadingResult() {
    this.setState({ downloadingResult: false });
  }

  downloadDetailedResult() {
    if (!this.props.result_detailed || this.props.result_detailed === "") return;
    this.setState({ downloadingDetailed: true });
    console.log("Downloading detailed result")
    DownloadFromRef(this.props.result_detailed, "Transavia_PQ_Detailed.csv", this.doneDownloadingDetailed);
  }

  doneDownloadingDetailed() {
    this.setState({ downloadingDetailed: false });
  }

  getUserCell() {
    return <Table.Cell collapsing>{this.props.user_display_name}</Table.Cell>;
  }

  getDescriptionCell() {
    var descout = this.props.description;
    if (!descout || descout === "") {
      descout = <i>No description</i>;
    }

    return (
      <Table.Cell>
        <span className="tp-download-original" onClick={this.downloadOriginal}>
          {this.state.downloadingOriginal && <Loader active size="tiny" inline />}
          {descout}
        </span>
      </Table.Cell>
    );
  }

  getTimestampCell() {
    const date = new Date(this.props.timestamp);
    const dateout = date.toLocaleDateString() + " " + date.toLocaleTimeString();
    return <Table.Cell collapsing>{dateout}</Table.Cell>;
  }

  getProcessingCell(colSpan) {
    return (
      <Table.Cell colSpan={colSpan} textAlign="center">
        <Icon name="setting" loading />
      </Table.Cell>
    )
  }

  getNewCell(colSpan) {
    return (
      <Table.Cell colSpan={colSpan} textAlign="center">
        <Loader active size="tiny" inline="centered" />
      </Table.Cell>
    )
  }

  getResultCell() {
    let content = null;
    if (this.props.isScenario) {
      content = <Loader active size="tiny" inline="centered" />;
      if (this.props.result && !this.state.downloadingResult) {
        content = <Icon name="download" />;
      }
    } else {
      content = <Icon name="check" />;
    }

    return (
      <Table.Cell key="statuscell" textAlign="center" onClick={this.downloadResult} className="tp-download-result">
        {content}
      </Table.Cell>
    )
  }

  getDetailedCell() {
    if (!this.props.isScenario) return null;

    let loading = false;
    if (!this.props.result_detailed) loading = true;
    if (this.state.downloadingDetailed) loading = true;
    return (
      <Table.Cell key="statuscell_detailed" textAlign="center" onClick={this.downloadDetailedResult} className="tp-download-result">
        {loading 
          ? <Loader active size="tiny" inline="centered" />
          : <Icon name="download" />
        }
      </Table.Cell>
    )
  }

  getFinalCell() {
    if (!this.props.isScenario) return null;

    return (
      <Table.Cell key="finalcell" textAlign="center">
        {this.props.result_detailed && <FileTableFinalCheckbox {...this.props} />}
      </Table.Cell>
    )
  }

  getDoneCells() {
    return [
      this.getResultCell(),
      this.getDetailedCell(),
      this.getFinalCell()
    ]
  }

  getResultCells() {
    var colSpan = 3;
    if (!this.props.isScenario) colSpan = 1;

    if (this.props.status === "processing") return this.getProcessingCell(colSpan);
    if (this.props.status === "error") return <FileTableErrorCell colSpan={colSpan} {...this.props} />;
    if (this.props.status === "new") return this.getNewCell(colSpan);
    
    return this.getDoneCells();;
  }

  getDeleteCell() {
    if (!this.props.canDelete) return null;

    return (
      <Table.Cell
        className="tp-download-result"
        collapsing
        icon="delete"
        onClick={() => DeleteRecord(this.props)}
      />
    )
  }

  render() {
    return (
      <Table.Row>
        {this.getUserCell()}
        {this.getDescriptionCell()}
        {this.getTimestampCell()}
        {this.getResultCells()}
        {this.getDeleteCell()}
      </Table.Row>
    );
  }
}

export default FileTableRow;


// WEBPACK FOOTER //
// ./src/pages/Home/FileTable/FileTableRow.js